// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1507":"b256c7e5","5085":"f79158ba","6492":"f79158ba","7078":"b4635f92"}[chunkId] + ".css";
};